const MuiSwitchOverrides = {
  MuiSwitch: {
    defaultProps: {
      color: 'info',
      disableRipple: true
    },
    styleOverrides: {
      root: ({
        theme,
        ownerState
      }) => ({
        padding: 0,
        borderRadius: theme.spacing(1.5),
        '& .MuiSwitch-switchBase': {
          padding: 0
        },
        ...(ownerState.size === 'small' && {
          height: theme.spacing(2.5),
          width: theme.spacing(4.5),
          '& .MuiSwitch-thumb': {
            width: '15px',
            height: '15px'
          }
        }),
        ...(ownerState.size === 'medium' && {
          height: theme.spacing(3),
          width: theme.spacing(5.5)
        })
      }),
      switchBase: {
        '&.Mui-checked+.MuiSwitch-track': {
          opacity: 1
        },
        '&.Mui-disabled+.MuiSwitch-track': {
          opacity: 0.5
        }
      },
      thumb: ({
        theme,
        ownerState
      }) => ({
        color: theme.palette.background.paper,
        boxShadow: 'initial',
        ...(ownerState.size === 'small' && {
          margin: 2.5
        }),
        ...(ownerState.size === 'medium' && {
          margin: 3,
          height: theme.spacing(2.25),
          width: theme.spacing(2.25)
        })
      }),
      track: ({
        theme
      }) => ({
        opacity: 1,
        background: theme.palette.gray50
      })
    }
  }
};

export { MuiSwitchOverrides };
